import type { RouteRecordRaw } from 'vue-router';
import { AdminMembersPage } from '@/pages/admin';

export const routeName = 'AdminMembros';

export const route: RouteRecordRaw = {
  path: 'membros',
  name: routeName,
  component: AdminMembersPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Membros',
    permissions: [{ action: 'read', subject: 'Admin' }],
  },
};
